import { Vue } from 'vue-class-component';
import { Job } from '@/types/Job';

class Props {
  entity: Job;
}

export default class InitiatorField extends Vue.with(Props) {
  render() {
    return <span>{this.entity.initiator.displayName}</span>;
  }
}
